module.exports = __webpack_public_path__ + "img/welcome-coins.73e16bff.png";